<div class="grant-list-container">
  <mat-selection-list>
    @for (grant of grants; track grant; let i = $index) {
      @if (grantOnPage(i)) {
        <mat-list-item
          matRipple
          (click)="setGrantSelection(grant.grantId, grant.subrecipientId)"
        >
          <span matListItemTitle role="heading" aria-level="3">{{
            grant | fullGrantDisplay
          }}</span>
          <span matListItemLine>{{ grant.roleName }}</span>
        </mat-list-item>
      }
    }
  </mat-selection-list>
</div>

<mat-paginator
  #paginator
  class="demo-paginator"
  (page)="handlePageEvent($event)"
  [length]="grants.length"
  [pageSize]="pageSize"
  [showFirstLastButtons]="true"
  [hidePageSize]="true"
  role="navigation"
  aria-label="Select Grant page"
>
</mat-paginator>
